module.exports = "html, body {\n  width: 100%;\n  height: 100%;\n  font-family: \"Helvetica Neue\", Helvetica, sans-serif;\n  color: #444;\n  -webkit-font-smoothing: antialiased;\n  background: #f0f0f0;\n  margin: 0px !important;\n}\n\n#container {\n  position: fixed;\n  width: 340px;\n  height: auto;\n  top: 45%;\n  left: 50%;\n  margin-top: -140px;\n  margin-left: -170px;\n}\n\nh1{\n  font-weight: 100\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/errors/errors.component.css
// module id = ./src/app/errors/errors.component.css
// module chunks = main